import { Api } from '../../../../../utility/client';

export const resendVerificationCode = async () => {
  const res = await Api.post<void>('/v1/user/mobilePhone/resend');
  return res.data;
};
